export default {
  // Page Meta
  meta: {
    title: 'Kontakt | NutriBot',
    description: 'Kontaktiere den NutriBot-Support. Wir helfen dir gerne bei Fragen zu deinem Ernährungsplan, technischen Problemen oder der Kontoverwaltung.',
  },

  // Hero Section
  hero: {
    title: 'Kontakt',
    subtitle: 'Wir sind für dich da. Nimm Kontakt mit unserem Team auf.',
  },

  // Contact Methods
  methods: {
    email: {
      title: 'E-Mail',
      content: 'support@nutribot.com',
      subtitle: 'Wir antworten innerhalb von 24 Stunden',
    },
    chat: {
      title: 'Live-Chat',
      content: 'Chatte mit unserem KI-Assistenten',
      subtitle: 'Rund um die Uhr verfügbar für sofortige Hilfe',
      button: 'Chat starten',
    },
    faq: {
      title: 'Hilfe-Center',
      content: 'Durchsuche unsere FAQ',
      subtitle: 'Finde Antworten auf häufige Fragen',
      link: 'FAQ anzeigen',
    },
  },

  // Contact Form
  form: {
    title: 'Sende uns eine Nachricht',
    subtitle: 'Fülle das Formular aus und wir melden uns bald bei dir.',
    fields: {
      firstName: 'Vorname',
      firstNamePlaceholder: 'Max',
      lastName: 'Nachname',
      lastNamePlaceholder: 'Mustermann',
      email: 'E-Mail-Adresse',
      emailPlaceholder: 'max@beispiel.de',
      subject: 'Betreff',
      subjectPlaceholder: 'Wähle einen Betreff',
      message: 'Nachricht',
      messagePlaceholder: 'Wie können wir dir helfen?',
    },
    subjects: {
      general: 'Allgemeine Anfrage',
      technical: 'Technischer Support',
      billing: 'Abrechnungsfrage',
      partnership: 'Partnerschaftsanfrage',
      feedback: 'Feedback',
      other: 'Sonstiges',
    },
    submit: 'Nachricht senden',
    submitting: 'Wird gesendet...',
    
    // Validation
    validation: {
      firstNameRequired: 'Vorname ist erforderlich',
      lastNameRequired: 'Nachname ist erforderlich',
      emailRequired: 'E-Mail ist erforderlich',
      emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
      subjectRequired: 'Bitte wähle einen Betreff',
      messageRequired: 'Nachricht ist erforderlich',
      messageMin: 'Nachricht muss mindestens 10 Zeichen lang sein',
    },

    // Success/Error
    success: {
      title: 'Nachricht gesendet!',
      message: 'Vielen Dank für deine Nachricht. Wir melden uns innerhalb von 24 Stunden bei dir.',
      button: 'Weitere Nachricht senden',
    },
    error: {
      title: 'Senden fehlgeschlagen',
      message: 'Etwas ist schief gelaufen. Bitte versuche es erneut oder kontaktiere uns direkt per E-Mail.',
      button: 'Erneut versuchen',
    },
  },

  // Additional Info
  info: {
    hours: {
      title: 'Support-Zeiten',
      weekdays: 'Montag - Freitag: 9:00 - 18:00 Uhr MEZ',
      saturday: 'Samstag: 10:00 - 16:00 Uhr MEZ',
      sunday: 'Sonntag: Geschlossen',
      note: 'KI-Assistent rund um die Uhr verfügbar',
    },
    location: {
      title: 'Standort Schweiz',
      city: 'Zürich, Schweiz',
      serving: 'Weltweit für Kunden verfügbar',
      note: 'Remote-first Team',
    },
  },

  // FAQ Section
  faq: {
    title: 'Häufig gestellte Fragen',
    subtitle: 'Schnelle Antworten auf häufige Fragen',
    questions: [
      {
        question: 'Wie kann ich auf VIP upgraden?',
        answer: 'Du kannst jederzeit über deine Profileinstellungen auf VIP upgraden. Klicke auf dein Plan-Badge und wähle "Auf VIP upgraden". Du erhältst sofortigen Zugang zu allen Premium-Funktionen inklusive KI-Ernährungscoach, personalisierten Ernährungsplänen und detaillierten Rezepten.',
      },
      {
        question: 'Kann ich mein Abo jederzeit kündigen?',
        answer: 'Ja! Du kannst dein Abonnement jederzeit über deine Profileinstellungen kündigen. Dein VIP-Zugang bleibt bis zum Ende deines aktuellen Abrechnungszeitraums aktiv. Keine Kündigungsgebühren oder Verpflichtungen.',
      },
      {
        question: 'Wie funktioniert der KI-Ernährungscoach?',
        answer: 'Unser KI-Coach (NutriBot) nutzt fortschrittliche Sprachmodelle, um personalisierte Ernährungsberatung zu bieten. Er lernt aus deinen Zielen, Vorlieben und Fortschritten, um individuelle Ernährungspläne zu erstellen, Fragen zu beantworten und deinen Plan basierend auf deinem Feedback anzupassen.',
      },
      {
        question: 'Bietet ihr Rückerstattungen an?',
        answer: 'Wir bieten eine 30-Tage-Geld-zurück-Garantie für VIP-Abonnements. Wenn du innerhalb der ersten 30 Tage nicht zufrieden bist, kontaktiere den Support für eine volle Rückerstattung. Nach 30 Tagen werden Rückerstattungen von Fall zu Fall geprüft.',
      },
      {
        question: 'Sind meine Daten sicher?',
        answer: 'Absolut. Wir verwenden Verschlüsselung auf Bankniveau zum Schutz deiner Daten. Alle Informationen werden sicher auf Supabase-Servern mit Ende-zu-Ende-Verschlüsselung gespeichert. Wir geben deine persönlichen Daten niemals ohne deine ausdrückliche Zustimmung an Dritte weiter.',
      },
      {
        question: 'Kann ich meine Ernährungspläne anpassen?',
        answer: 'Ja! VIP-Mitglieder können ihre Ernährungspläne vollständig anpassen. Du kannst Mahlzeiten tauschen, Kalorien anpassen, Ernährungspräferenzen ändern und bestimmte Zutaten ausschließen. Der KI-Coach generiert deinen Plan basierend auf deinen Präferenzen neu.',
      },
      {
        question: 'Unterstützt ihr Ernährungseinschränkungen?',
        answer: 'Ja, wir unterstützen alle gängigen Ernährungseinschränkungen wie vegetarisch, vegan, glutenfrei, laktosefrei, Nussallergien und mehr. Du kannst deine Einschränkungen während des Onboardings angeben oder jederzeit in deinen Profileinstellungen aktualisieren.',
      },
      {
        question: 'Wie kontaktiere ich den Support?',
        answer: 'Du erreichst uns per E-Mail unter [support@nutribot.com](mailto:support@nutribot.com) oder über das Kontaktformular auf dieser Seite. Bei dringenden Anliegen ist die E-Mail der schnellste Weg, um unser Support-Team zu erreichen.',
      },
    ],
  },

  // Toast Messages
  toast: {
    messageSent: 'Nachricht erfolgreich gesendet!',
    messageFailed: 'Nachricht konnte nicht gesendet werden',
    emailCopied: 'E-Mail-Adresse in die Zwischenablage kopiert',
    rateLimitExceeded: 'Zu viele Anfragen. Bitte versuche es später erneut.',
  },
};
